"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TablePagination.default;
  }
});

var _TablePagination = _interopRequireDefault(require("./TablePagination"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/TablePagination/index.js
 ** module id = 942
 ** module chunks = 0
 **/